// Configuración centralizada para breadcrumbs
export interface BreadcrumbRoute {
  title: string;
  parent?: string;
  showParam?: boolean; // Para rutas con parámetros dinámicos como :id
}

// Configuración de todas las rutas de la aplicación
export const breadcrumbConfig: Record<string, BreadcrumbRoute> = {
  // Página principal
  '/dashboard': {
    title: 'Dashboard'
  },

  // Tràmits - páginas con Dashboard como padre directo
  '/tramits/iniciar-nou': {
    title: 'Iniciar Nou Tràmit',
    parent: '/dashboard'
  },
  '/tramits/consultar': {
    title: 'Consultar Tràmits',
    parent: '/dashboard'
  },
  '/tramits/detall/:id': {
    title: 'Detall del Tràmit',
    parent: '/tramits/consultar',
    showParam: true
  },

  // Trameses - páginas con Dashboard como padre directo
  '/trameses/iniciar-nova': {
    title: 'Iniciar Nova Tramesa',
    parent: '/dashboard'
  },
  '/trameses/consultar': {
    title: 'Consultar Trameses',
    parent: '/dashboard'
  },
  '/trameses/detall/:id': {
    title: 'Detall de la Tramesa',
    parent: '/trameses/consultar',
    showParam: true
  },
  '/trameses/quadre-control': {
    title: 'Quadre de Control de Trameses',
    parent: '/dashboard'
  },

  // Comunicaciones detalle (ruta con parámetro)
  '/comunicaciones/detall/:id': {
    title: 'Detall de la comunicació',
    parent: '/comunicaciones',
    showParam: true
  },

  // Páginas directas
  '/comunicaciones': {
    title: 'Comunicacions',
    parent: '/dashboard'
  },
  '/documentacion': {
    title: 'Documentació',
    parent: '/dashboard'
  },

  // Página de componentes
  '/componentes': {
    title: 'Componentes',
    parent: '/dashboard'
  },
};